import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import { useTranslation } from "components/i18n/source";

import styles from "./Text.module.scss";

function Text({
  element,
  className,
  children,
  types,
  translateKey,
  interpolation,
  ...props
}) {
  const { t } = useTranslation();
  const hasChildren = children !== undefined && children !== null;
  if (!(hasChildren || translateKey)) return null;

  return React.createElement(
    element,
    {
      ...props,
      className: classnames(
        styles.base,
        ...types.map(type => styles[type]),
        className,
      ),
    },
    translateKey ? t(translateKey, interpolation) : children,
  );
}

Text.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  translateKey: PropTypes.string,
  interpolation: PropTypes.object,
  element: PropTypes.string,
  types: PropTypes.arrayOf(PropTypes.string),
};

Text.defaultProps = {
  children: null,
  className: null,
  translateKey: "",
  interpolation: {},
  element: "p",
  types: [],
};

export default Text;
